const add = (key, value) => localStorage.setItem(key, value);

const get = key => localStorage.getItem(key);

const remove = key => localStorage.removeItem(key);

const cleanupLocalStorage = (regex) => {
  Object.keys(localStorage)
    .forEach((key) => {
      if (new RegExp(regex).test(key)) {
        localStorage.removeItem(key);
      }
    });
};

export default {
  add,
  get,
  remove,
  cleanupLocalStorage,
};
